import React from 'react';
import CompanyList from '../components/CompanyList';

const Companies: React.FC = () => {
  return (
    <div className="max-w-app mx-auto px-6 py-8">
      <CompanyList />
    </div>
  );
};

export default Companies;
